import { Injectable, Injector } from '@angular/core';
import { RegMode } from './mode/reg-mode';
import { AuthMode } from './mode/auth-mode';
import { ModeInterface } from './mode/mode.interface';
import { RecoveryMode} from './mode/recovery-mode';

export enum Mode {
  REG ,
  AUTH,
  RECOVERY
}

@Injectable({
  providedIn: 'root'
})
export class ModeService {

  constructor(private injector: Injector) { }

  getService(mode: Mode): ModeInterface {
    console.log(mode, Mode.REG);
    switch (mode) {
      case Mode.REG:
        return this.injector.get(RegMode);
      case Mode.RECOVERY:
        return this.injector.get(RecoveryMode);
      case Mode.AUTH:
      default:
        return this.injector.get(AuthMode);

    }
  }
}
